import axios from "axios";
import { I18n } from "react-redux-i18n";
import {
  REEL_LIST_ATTEMPT,
  REEL_LIST_SUCCESS,
  REEL_LIST_FAILED,
  REEL_DELETE_SUCCESS,
} from "../types/reelTypes";
import { config } from "../../config";

const url_api = config.api.godiway;

export const loadList = (data) => async (dispatch) => {
  dispatch({ type: REEL_LIST_ATTEMPT });
  const isAuth = Boolean(data.token);
  await axios
    .get(url_api + (isAuth ? "reel" : "reel/out"), {
      params: {
        id: data.user_id,
        lang: I18n.t("locale"),
        index: data.index || 0,
        ...(data.store_id ? { store_id: data.store_id } : {}),
      },
      ...(isAuth ? { headers: { Authorization: `Bearer ${data.token}` } } : {}),
    })
    .then((response) => {
      if (response.status < 300 && response.data.status === "Success") {
        dispatch({
          type: REEL_LIST_SUCCESS,
          data: response.data.body,
        });
      } else {
        dispatch({
          type: REEL_LIST_FAILED,
          error: response.data.body || "try_later",
        });
      }
    })
    .catch(() => {
      dispatch({ type: REEL_LIST_FAILED, error: "try_later" });
    });
};

export const removeFromList = (id) => ({
  type: REEL_DELETE_SUCCESS,
  id,
});
